import { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import { fontStyles } from "../style/common_font";
import { CenterView } from "../style/common_style";
import { openKakaoLiveInExternalBrowser } from "../tool/kakaoBrowser";

const Container = styled(CenterView)`
  flex-direction: column;
  min-height: 100dvh;
  padding: 24px;
  box-sizing: border-box;
  text-align: center;
  h1 { font-size: 22px; }
  p {
    max-width: 24rem;
    font-size: 16px;
    line-height: 1.6;
    color: var(--user-text-muted);
  }
  button {
    width: 100%;
    max-width: 24rem;
    min-height: 3.5rem;
    padding: 12px 20px;
    margin-top: 1rem;
    border: 0;
    font-size: 16px;
    ${fontStyles.semiBold}
    border-radius: 50px;
    color: white;
    background: linear-gradient(90deg, #7955f0, #3209b9);
    cursor: pointer;
    &:focus-visible { outline: 3px solid var(--user-accent); outline-offset: 4px; }
  }
`;

const KaKaoban_page = () => {
  const cancelHandoff = useRef<(() => void) | undefined>(undefined);
  const openNewPage = useCallback(() => {
    cancelHandoff.current?.();
    cancelHandoff.current = openKakaoLiveInExternalBrowser();
  }, []);

  useEffect(() => {
    // Cancel the first scheduled attempt during React StrictMode's effect replay.
    const timer = window.setTimeout(openNewPage, 0);
    return () => {
      window.clearTimeout(timer);
      cancelHandoff.current?.();
    };
  }, [openNewPage]);

  return (
    <Container as="main">
      <h1>라이브를 외부 브라우저로 연결합니다</h1>
      <p>자동으로 이동하지 않으면 아래 버튼을 눌러주세요.</p>
      <button type="button" onClick={openNewPage}>외부 브라우저로 라이브 보기</button>
      <p>계속 이 화면이 보이면 카카오톡 메뉴에서 ‘다른 브라우저로 열기’를 선택해주세요.</p>
      <p>외부 브라우저가 열린 뒤에도 이 창이 남아 있으면 상단 닫기 버튼을 눌러주세요.</p>
    </Container>
  );
};

export default KaKaoban_page;
